import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class INDRADropdownService {
	private openDropdowns: Set<string> = new Set();
	private dropdownState = new BehaviorSubject<boolean>(false);
	isOpen$ = this.dropdownState.asObservable();

	isOpen(id: string): boolean {
		return this.openDropdowns.has(id);
	}

	open(id: string): void {
		this.openDropdowns.add(id);
		this.emitState();
	}

	close(id: string): void {
		this.openDropdowns.delete(id);
		this.emitState();
	}

	closeAll(): void {
		this.openDropdowns.clear();
		this.emitState();
	}

	toggle(id: string): void {
		if (this.isOpen(id)) {
			this.close(id);
		} else {
			this.open(id);
		}
	}

	private emitState(): void {
		this.dropdownState.next(this.openDropdowns.size > 0);
	}
}
